import { render, staticRenderFns } from "./OpenApp.vue?vue&type=template&id=54f76a06&scoped=true&"
import script from "./OpenApp.vue?vue&type=script&lang=ts&"
export * from "./OpenApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f76a06",
  null
  
)

export default component.exports